<template>
    <section class="body-card">
        <div v-if="numRuleGroups > 0" class="add-new-rule-comparison" @click="addNewRuleMap">
            <span>
                {{ `${$t('funnel.edit.decision.plus.symbol')} ${ruleGroup.comparison}` }}
            </span>
        </div>
        <section class="separator-block-wrapper">
            <div class="separator-block-comparison">
                {{ $t('funnel.edit.decision.or.label') }}
            </div>
        </section>
    </section>
</template>

<script>

export default {
    name: 'DecisionDiamondRuleItem',
    props: {
        ruleGroup: {
            type: Object,
            required: true,
        },
        numRuleGroups: {
            type: Number,
            required: true,
        },
    },
    emits: ['add-new-rule-map'],
    methods: {
        addNewRuleMap() {
            this.$emit('add-new-rule-map', this.ruleGroup.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.body-card {
    margin-left: $spacing-250;
}

.separator-block {
    padding-top: $spacing-400;
    border-bottom: solid px-to-rem(1) $color-gray-200;
}

.add-new-rule-comparison {
    font-weight: bold;
    color: $color-blue;
    cursor: pointer;
    padding-bottom: $spacing-250;
}

.separator-block-wrapper {
    position: relative;
    margin-left: -20px;
    padding: $spacing-075;
    margin-top: $spacing-250;
}

.separator-block-comparison {
    background-color: $color-gray-100;
    width: 31px;
    height: 24px;
    border-radius: $spacing-075;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-left: $spacing-250;
}

.separator-block-wrapper:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: $color-gray-300;
    left: 0;
    top: 50%;
}

.no-rule-alert-msg {
    margin-left: $spacing-200;
}

</style>
